﻿import { filter, find, map } from "lodash";
import { Enums } from "../../helper/enums";
import { CustomDropDown } from "../custom-dropdown";

//Models
export class FormElement {
  public formElementId: string;
  public elementType: string;
  public isRequired: boolean;
  public maxLength: number;
  public linkedToId: string;
  public elementName: string;
  public elementOptions: ElementOption[];
  public payload: any;
  public inputValue: string;
  /** API field name; hint text inside inputs when set. */
  public placeHolder: string | null;
}

export class ElementOption {
  public elementOptionId: number;
  public elementOptionName: string;
}

export class FormPreviewModel {
  public formElementId: string;
  /** Visible field title (from elementName). */
  public fieldLabel: string;
  /** Plain-text hint shown inside inputs (from template inputValue). */
  public placeholder: string;
  public inputValue: any;
  public elementType: string;
  public isRequired: boolean;
  public inputArray: any[];
  public linkedToId: string;
  public error: boolean;
  public elementOptions: ElementOption[];
  public hideElement: boolean;
  public payload: any;
}

export class FormResponseByIdModel {
  public formTitle: string;
  public formElements: FormPreviewModel[];
  public submittedAt: string;
}

export class formContentResponseModel {
  public title: string;
  public description: string;
  public formElements: FormElement[];
}

export class FormRequestModel {
  public id: string;
  public type: string;
  public createdByContactId: string;
  public draftFormRelationId: string;
  public title: string;
  public formElements: FormPreviewModel[];
  public groupIds: number[];
  public tagIds: number[];
  public clientIds: number[];
  public version: number;
}

export class FormElementType {
  id: string;
  name: string;
  iconClass: string;
}

export class FormElementOption {
  blockName: string;
  formElementTypes: FormElementType[];
}

export class FormSubmission {
  public id: string;
  public formId: string;
  public submittedAt: string;
  public formElements: FormPreviewModel[];
}

export class FormSubmissionHeader {
  public formElementId: string;
  public elementType: string;
  public headerName: string;
}

export class TicketFormResponseModel {
  public headerName: string;
  public headerValue: string;
  public iconClass: string;
}

export class FormSettingRequestModel {
  public id: string;
  public groupIds: number[];
  public tagIds: number[];
  public clientIds: number[];
  public notifyGroup: boolean;
}

export class ConditionalLogicUIModel {
  public conditionalLogicId: string;

  public conditionOperatorDropdown: CustomDropDown.IDropDown;
  public conditionOperatorDropdownKey: number;

  public when: ConditionUIModel[];
  public then: ActionUIModel[];
}

export class ConditionUIModel {
  public localId: number;

  public formElementDropdown: CustomDropDown.IDropDown;
  public formElementDropdownKey: number;

  public operatorDropdown: CustomDropDown.IDropDown;
  public operatorDropdownKey: number;

  public valueDropdown: CustomDropDown.IDropDown;
  public valueDropdownKey: number;
}

export class ActionUIModel {
  public localId: number;

  public formElementDropdown: CustomDropDown.IDropDown;
  public formElementDropdownKey: number;

  public actionDropdown: CustomDropDown.IDropDown;
  public actionDropdownKey: number;
}

export class ConditionalLogic {
  public conditionalLogicId: string;
  public operatorForConditions: Enums.BooleanOperator;
  public when: Condition[];
  public then: Action[];
}

export class Condition {
  public formElementId: string;
  public operator: Enums.WhenLogicOperator;
  public value: any;
}

export class Action {
  public formElementIds: string[];
  public action: Enums.ConditionalLogicAction;
}

export class FormSubmissionEmailModel {
  public emailAddress: string;
  public formId: string;
}

//Form Settings

export const sizeOfGuid: number = 6;
export const customTagIdCharacters: string = "0123456789";
let globalKey: number = 1;
export const customClassesForConditionalLogicDropdowns =
  "formmanagevalue previewformmanagevalue customformselectfield";

export const formElementTypes = () => {
  let formElementTypesInArray = map(formElementOptions, "formElementTypes");
  let types: FormElementType[] = [];
  for (let type of formElementTypesInArray) {
    types = types.concat(type);
  }

  return types;
};

export const layoutBlockElementIds = () => {
  let layoutBlock = find(formElementOptions, function (option) {
    return option.blockName == "Layout Blocks";
  });
  let elementIds: string[] = map(layoutBlock?.formElementTypes, "id");
  elementIds.push(Enums.FormElementType.Question);
  return elementIds;
};

export const formElementOptions: FormElementOption[] = [
  {
    blockName: "Questions",
    formElementTypes: [
      {
        id: Enums.FormElementType.QuestionAndShortAnswer,
        name: "Question + Short Answer",
        iconClass: "far fa-grip-lines  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndLongAnswer,
        name: "Question + Long Answer",
        iconClass: "far fa-bars  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndMultipleChoice,
        name: "Question + Multiple Choice",
        iconClass: "far fa-check-circle  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndCheckbox,
        name: "Question + Checkbox",
        iconClass: "far fa-check-square  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndNumber,
        name: "Question + Number",
        iconClass: "far fa-hashtag  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndEmail,
        name: "Question + Email",
        iconClass: "far fa-envelope  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndPhoneNumber,
        name: "Question + Phone number",
        iconClass: "far fa-phone flipicon  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndLink,
        name: "Question + Link",
        iconClass: "far fa-link  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndDate,
        name: "Question + Date",
        iconClass: "far fa-calendar-alt  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndTime,
        name: "Question + Time",
        iconClass: "far fa-clock  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndDropdown,
        name: "Question + Dropdown",
        iconClass: "far fa-angle-down  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.QuestionAndToggle,
        name: "Question + Yes/No",
        iconClass: "far fa-toggle-on  secondary--text mr-1",
      },
    ],
  },

  {
    blockName: "Layout Blocks",
    formElementTypes: [
      {
        id: Enums.FormElementType.Heading1,
        name: "Heading 1",
        iconClass: "far fa-h1  secondary--text",
      },
      {
        id: Enums.FormElementType.Heading2,
        name: "Heading 2",
        iconClass: "far fa-h2  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Heading3,
        name: "Heading 3",
        iconClass: "far fa-h3  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Label,
        name: "Label",
        iconClass: "far fa-tag  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Text,
        name: "Text",
        iconClass: "fal fa-font   secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Divider,
        name: "Divider",
        iconClass: "far fa-divide  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.FormSubmissionMessage,
        name: `'Thank you' page`,
        iconClass: "fal fa-smile  secondary--text mr-1",
      },
    ],
  },

  {
    blockName: "Input Blocks",
    formElementTypes: [
      {
        id: Enums.FormElementType.ShortAnswer,
        name: "Short Answer",
        iconClass: "far fa-grip-lines  secondary--text",
      },
      {
        id: Enums.FormElementType.LongAnswer,
        name: "Long Answer",
        iconClass: "far fa-bars  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.MultipleChoice,
        name: "Multiple Choice",
        iconClass: "far fa-check-circle  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Checkbox,
        name: "Checkbox",
        iconClass: "far fa-check-square   secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Number,
        name: "Number",
        iconClass: "far fa-hashtag  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Email,
        name: "Email",
        iconClass: "far fa-envelope  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.PhoneNumber,
        name: "Phone Number",
        iconClass: "far fa-phone flipicon  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Link,
        name: "Link",
        iconClass: "far fa-link secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Date,
        name: "Date",
        iconClass: "far fa-calendar-alt  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Time,
        name: "Time",
        iconClass: "far fa-clock  secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Dropdown,
        name: "Dropdown",
        iconClass: "far fa-angle-down secondary--text mr-1",
      },
      {
        id: Enums.FormElementType.Toggle,
        name: "Yes/No",
        iconClass: "far fa-toggle-on  secondary--text mr-1",
      },
    ],
  },

  {
    blockName: "Advanced Blocks",
    formElementTypes: [
      {
        id: Enums.FormElementType.ConditionalLogic,
        name: "Conditional Logic",
        iconClass: "far fa-grip-lines secondary--text",
      },
    ],
  },
];

//Functions

export function setFocusOnElement(elementId: string, elementType: string) {
  let customElement = document.getElementById(elementId);
  if (customElement != null) {
    customElement.focus();
    let layoutBlockElementIdArray = layoutBlockElementIds();
    if (layoutBlockElementIdArray.includes(elementType)) {
      placeCaretAtEnd(customElement);
    }
  }
}

export function placeCaretAtEnd(el: any) {
  el.focus();
  if (
    typeof window.getSelection != "undefined" &&
    typeof document.createRange != "undefined"
  ) {
    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    const sel = window.getSelection();
    if (sel != null) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }
}

export function getCaretPosition(elementId: string) {
  let element = document.getElementById(elementId) as HTMLInputElement;
  if (element != null) {
    let caretPosition: number = element.selectionStart || 0;
    return caretPosition;
  }

  return 0;
}

export function parseFormResponseElementForHeaderValue(
  formElement: FormPreviewModel | undefined,
) {
  if (formElement != null) {
    if (formElement.elementType == Enums.FormElementType.Checkbox) {
      //Array expected
      if (formElement.inputValue != null && formElement.inputValue != "") {
        let selectedValues: number[] = JSON.parse(formElement.inputValue);
        let selectedElementOptions = filter(
          formElement.elementOptions,
          function (elementOption: ElementOption) {
            return selectedValues.includes(elementOption.elementOptionId);
          },
        );

        let elementOptionNames: string[] = map(
          selectedElementOptions,
          "elementOptionName",
        );
        return elementOptionNames.join(",");
      } else {
        return "-";
      }
    } else if (
      formElement.elementType == Enums.FormElementType.MultipleChoice
    ) {
      if (formElement.inputValue != null && formElement.inputValue != "") {
        let elementOptionId: number = JSON.parse(formElement.inputValue);
        let selected = find(
          formElement.elementOptions,
          function (elementOption: ElementOption) {
            return elementOptionId == elementOption.elementOptionId;
          },
        );

        if (selected != null) {
          return selected.elementOptionName;
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    } else if (formElement.elementType == Enums.FormElementType.Dropdown) {
      if (formElement.inputValue != null && formElement.inputValue != "") {
        let elementOptionId: number = JSON.parse(formElement.inputValue);
        let selected = find(
          formElement.elementOptions,
          function (elementOption: ElementOption) {
            return elementOptionId == elementOption.elementOptionId;
          },
        );

        if (selected != null) {
          return selected.elementOptionName;
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    } else if (formElement.elementType == Enums.FormElementType.Toggle) {
      //Boolean expected
      if (formElement.inputValue != null && formElement.inputValue != "") {
        let toggleValue: boolean = JSON.parse(formElement.inputValue);
        let option1: string =
          formElement.elementOptions != null &&
          formElement.elementOptions[0] != null
            ? formElement.elementOptions[0].elementOptionName
            : "No";
        let option2: string =
          formElement.elementOptions != null &&
          formElement.elementOptions[1] != null
            ? formElement.elementOptions[1].elementOptionName
            : "Yes";

        if (!toggleValue) {
          return option1;
        } else {
          return option2;
        }
      } else {
        return "-";
      }
    } else {
      if (formElement.inputValue != null && formElement.inputValue != "") {
        return formElement.inputValue;
      } else {
        return "-";
      }
    }
  } else {
    return "-";
  }
}

export function getIncrementalKey() {
  globalKey = globalKey + 1;
  return globalKey;
}
